import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.416 34.137a2.295 2.295 0 0 1 1.892-.992 2.289 2.289 0 0 1 2.294 2.284 2.29 2.29 0 0 1-2.294 2.284 2.295 2.295 0 0 1-1.985-1.138H18.17a6.876 6.876 0 0 1-6.787 5.706c-3.801 0-6.883-3.068-6.883-6.852 0-2.33 1.169-4.39 2.955-5.627l1.316 1.871a4.557 4.557 0 0 0-1.977 3.756c0 2.523 2.055 4.568 4.589 4.568 2.26 0 4.14-1.628 4.518-3.77v-2.09h19.515ZM9.33 34.48a2.286 2.286 0 0 1 2.112-1.432l8.603-14.902a6.859 6.859 0 0 1-1.565-8.713 6.856 6.856 0 0 1 9.365-2.513 6.844 6.844 0 0 1 3.4 5.344l-2.276.2a4.57 4.57 0 0 0-8.51-1.889 4.571 4.571 0 0 0 1.537 6.164l1.258.726-9.745 16.878c.277.578.307 1.265.043 1.884A2.287 2.287 0 1 1 9.33 34.48Zm14.886-19.36a2.256 2.256 0 0 1-1.848-1.123 2.275 2.275 0 0 1 .848-3.103 2.275 2.275 0 0 1 3.112.817c.408.707.388 1.546.019 2.218l8.56 14.826c3.092-1.192 6.663-.013 8.356 2.92 1.875 3.247.736 7.415-2.544 9.309a6.87 6.87 0 0 1-6.333.293l.973-2.06a4.58 4.58 0 0 0 4.228-.193c2.187-1.263 2.946-4.042 1.696-6.207-1.25-2.165-4.036-2.896-6.223-1.634l-.028.017-.02-.034-1.149.663-9.647-16.709Z",
    fill: "currentColor"
  }));
};

var SvgWebhook = styled(SvgComponent).withConfig({
  displayName: "Webhook__SvgWebhook",
  componentId: "sc-1txk2ld-0"
})(["", " ", ""], size, color);
export default SvgWebhook;